/**
 * Copyright (c) HashiCorp, Inc.
 */

import Component from '@glimmer/component';
import { concat } from '@ember/helper';
import { eq, gt } from 'ember-truth-helpers';
import { HdsBadge } from '@hashicorp/design-system-components/components';

export interface MetadataHealthCheckBadgeSetSignature {
  Args: {
    type: string;
    successCount?: number;
    criticalCount?: number;
    warningCount?: number;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class MetadataHealthCheckBadgeSet extends Component<MetadataHealthCheckBadgeSetSignature> {
  get total() {
    return (
      (this.args.successCount || 0) +
      (this.args.criticalCount || 0) +
      (this.args.warningCount || 0)
    );
  }

  <template>
    {{#if (gt this.total 0)}}
      {{#if (gt @criticalCount 0)}}
        <HdsBadge
          @color="critical"
          @icon="x"
          @text={{concat @criticalCount "/" this.total " " @type " checks"}}
          @size="small"
          data-test-health-check-critical={{@type}}
        />
      {{/if}}

      {{#if (gt @warningCount 0)}}
        <HdsBadge
          @color="warning"
          @icon="alert-triangle"
          @text={{concat @warningCount "/" this.total " " @type " checks"}}
          @size="small"
          data-test-health-check-warning={{@type}}
        />
      {{/if}}

      {{#if (eq @successCount this.total)}}
        <HdsBadge
          @color="success"
          @icon="check"
          @text={{concat @successCount "/" this.total " " @type " checks"}}
          @size="small"
          data-test-health-check-success={{@type}}
        />
      {{/if}}
    {{/if}}
  </template>
}
